var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"fixed-header":"","disable-pagination":"","hide-default-footer":"","headers":_vm.headers,"items":_vm.items,"no-data-text":"Sem dados"},scopedSlots:_vm._u([{key:"item.text",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.text)+"\n  ")]}},{key:"item.count",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("localeString")(item['count']))+"\n  ")]}},{key:"item.representation",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("percent")(_vm._f("localeString")(_vm.locale(item['representation'], 2),1)))+" ")]}},{key:"item.revenue",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(_vm._f("localeString")(_vm.locale(item['revenue'], 2),2)))+" ")]}},{key:"item.averageTicket",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("currency")(_vm._f("localeString")(_vm._f("hifen")(_vm.locale(item['averageTicket'], 2)),2)))+" ")]}},{key:"item.coupons",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("localeString")(item['coupons']))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }